import Vue from 'vue';
import Vuex from 'vuex';

import locale from './modules/locale';
import layout from './modules/layout';
import tax from './modules/tax';
import publisher from './modules/publisher';
import app from './modules/app/app';
import draftApp from './modules/app/draftApp';
import category from './modules/category';
import settlement from './modules/settlement';
import agentPreferences from './modules/agentPreferences';
import bids from './modules/advertisement/bids';
import apps from './modules/apps';
import mailService from './modules/advertisement/mailService';
import bulkImportBids from './modules/advertisement/bulkImportBids';
import searchAdsCampaignHints from './modules/advertisement/searchAdsCampaignHints';
import contract from './modules/advertisement/contract';
import cpuArchitectures from './modules/cpuArchitectures';
import featureFlags from './modules/featureFlags';
import { ENVIRONMENT } from '../config';
import modal from '@/plugins/modal/storeModule';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    locale,
    layout,
    tax,
    app,
    draftApp,
    publisher,
    category,
    settlement,
    agentPreferences,
    bids,
    apps,
    mailService,
    bulkImportBids,
    searchAdsCampaignHints,
    contract,
    modal,
    cpuArchitectures,
    featureFlags,
  },
  strict: ENVIRONMENT !== 'production',
});
